import React, {
  ReactNode,
  ChangeEvent,
  useCallback,
}                    from 'react';
import styled        from 'styled-components';
import { useToggle } from '@utils/useToggle';
import { Button }    from '@components/index';

interface IProps {
  id        : string;
  label     : string;
  margin?   : string;
  children? : ReactNode;
  disabled? : boolean;
  onUpload  : (file: File) => void;
}

const StyledButton = styled(Button)`
  && {
    font-weight: 300;

    input {
      display: none;
    }
  }
` as any;

const imageTypeRegex = new RegExp('^image/');

export const UploadButton = ({
  id,
  label,
  children,
  disabled,
  onUpload,
  ...props
}: IProps): JSX.Element => {
  const [isLoading, toggleIsLoading] = useToggle();

  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>): void => {
      toggleIsLoading();
      event.preventDefault();

      const source = event.target.files?.[0];

      if (source && imageTypeRegex.test(source.type)) {
        onUpload(source);
      }

      toggleIsLoading();
    },
    [onUpload, toggleIsLoading],
  );

  return (
    <label htmlFor={id}>
      <StyledButton
        component = "span"
        width     = "220px"
        disabled  = {disabled || isLoading}
        {...props}
      >
        <input
          id       = {id}
          type     = "file"
          accept   = "image/*"
          value    = ""
          disabled = {disabled || isLoading}
          onChange = {handleOnChange}
        />
        {isLoading ? 'Loading...' : children || label}
      </StyledButton>
    </label>
  );
};

UploadButton.defaultProps = {
  id      : 'photo-upload',
  label   : 'Upload Photo',
  bgcolor : 'blue',
};
